interface MonksFlowMarkIconProps {
  className?: string;
}

/**
 * The MonksFlow interlocking-rings mark, as used in the favicon.
 *
 * Marks something as a MonksFlow-supplied default (a Standard field or list) —
 * deliberately NOT a sparkle/star, which reads as "AI generated" everywhere
 * else in the product.
 *
 * A plain SVG rather than an MUI `SvgIcon` like its neighbours here: it renders
 * inside monks-ui Badges alongside lucide icons, so it needs to size from a
 * Tailwind `size-*` class and take its colour from `currentColor`. The viewBox
 * is cropped to the mark itself — the favicon's rounded background plate is
 * dropped so the glyph fills the box.
 */
export function MonksFlowMarkIcon({ className }: MonksFlowMarkIconProps) {
  return (
    <svg
      viewBox="38 63 124 73"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      data-testid="MonksFlowMarkIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.2493 117.075C96.3384 121.443 105.29 124.148 115.594 124.148C125.756 124.148 134.722 121.451 140.86 117.065C146.751 112.855 150.1 107.138 150.1 99.7741C150.1 92.0989 146.768 86.2736 141.036 82.0636C135.045 77.663 126.142 74.9002 115.594 74.9002C105.247 74.9002 96.3221 77.5621 90.2696 81.9268C84.5087 86.0813 81.0885 91.8864 81.0885 99.7741C81.0885 107.182 84.4152 112.89 90.2493 117.075ZM71.1883 99.7741C71.1883 121.664 91.8276 134.048 115.594 134.048C139.11 134.048 160 121.664 160 99.7741C160 77.6338 139.861 65 115.594 65C91.8276 65 71.1883 77.1334 71.1883 99.7741Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.061 117.075C65.1502 121.443 74.1018 124.148 84.4059 124.148C94.5681 124.148 103.533 121.451 109.672 117.065C115.562 112.855 118.911 107.138 118.911 99.7741C118.911 92.0989 115.58 86.2736 109.848 82.0636C103.857 77.663 94.9535 74.9002 84.4059 74.9002C74.0592 74.9002 65.1338 77.5621 59.0814 81.9268C53.3204 86.0813 49.9003 91.8864 49.9003 99.7741C49.9003 107.182 53.2269 112.89 59.061 117.075ZM40 99.7741C40 121.664 60.6393 134.048 84.4059 134.048C107.922 134.048 128.812 121.664 128.812 99.7741C128.812 77.6338 108.673 65 84.4059 65C60.6393 65 40 77.1334 40 99.7741Z"
      />
    </svg>
  );
}
